import cx from 'clsx';
import type { ReactElement, ReactNode } from 'react';
import { ListItem, type ListItemProps } from './item';
import styles from './list.module.css';

export interface Item {
  icon: ListItemProps['icon'];
  key: string;
  text: ReactNode;
}

interface ListProps {
  items: Item[];
  spacing?: 'small' | 'default';
  className?: string;
}

export function List({ items, spacing, className, ...props }: ListProps): ReactElement {
  return (
    <ul
      className={cx(styles.list, spacing === 'small' && styles.smallSpacing, className)}
      {...props}
    >
      {items.map(item => (
        <ListItem icon={item.icon} key={item.key}>
          {item.text}
        </ListItem>
      ))}
    </ul>
  );
}
